/**
 * Generates a unique idempotency key for a single transfer attempt.
 *
 * Use it with a lazy useState initialiser so the key is stable across
 * re-renders and retries of the SAME transfer, but a new transfer (new mount)
 * gets a fresh key:
 *
 *   const [idempotencyKey] = useState(newIdempotencyKey);
 *
 * Prefers crypto.randomUUID (all modern browsers); falls back to a
 * timestamp+random string on older runtimes.
 */
export const newIdempotencyKey = () => {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return `armf-${crypto.randomUUID()}`;
  }
  return `armf-${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
};
